import angular from 'angular';
import DynamicBannerModule from './dynamic-banner/dynamic-banner';
import CarouselBannerModule from './carousel-banner/carousel-banner';
import SideBannersModule from './side-banners/side-banners';



let BannersModule = angular.module('shared.components.banners', [
  DynamicBannerModule.name,
  SideBannersModule.name,
  CarouselBannerModule.name

]);

export default BannersModule;



// WEBPACK FOOTER //
// ./www/components/shared/components/banners/banners.js